var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.1377 11.552H13.1407V12.6018H14.1378C14.4272 12.6019 14.6627 12.3663 14.6627 12.0769C14.6627 11.7874 14.4272 11.552 14.1377 11.552Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.06019 11.5521C8.64059 11.5521 8.29917 11.8934 8.29917 12.3131V12.6019H9.82121V12.3131C9.82121 11.8934 9.4798 11.5521 9.06019 11.5521Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 8.29199V17.1501C2 18.1701 2.82988 19 3.84992 19H21.1981C22.2181 19 23.048 18.1701 23.048 17.1501V8.29199H2ZM11.0545 15.0041C11.0545 15.3447 10.7784 15.6208 10.4378 15.6208C10.0973 15.6208 9.82119 15.3447 9.82119 15.0041V13.8352H8.29919V15.0041C8.29919 15.3447 8.0231 15.6208 7.68255 15.6208C7.342 15.6208 7.06591 15.3447 7.06591 15.0041V12.3131H7.06587C7.06587 11.2134 7.96054 10.3188 9.06017 10.3188C10.1598 10.3188 11.0545 11.2134 11.0545 12.3131V15.0041ZM14.1378 13.8351H13.1406V15.0041C13.1406 15.3446 12.8646 15.6207 12.524 15.6207C12.1835 15.6207 11.9074 15.3446 11.9074 15.0041V10.9353C11.9074 10.5948 12.1835 10.3187 12.524 10.3187H14.1378C15.1072 10.3187 15.896 11.1074 15.896 12.0769C15.896 13.0464 15.1072 13.8351 14.1378 13.8351ZM17.9821 15.004C17.9821 15.3446 17.7061 15.6207 17.3655 15.6207C17.025 15.6207 16.7489 15.3446 16.7489 15.004V10.9353C16.7489 10.5948 17.025 10.3187 17.3655 10.3187C17.7061 10.3187 17.9821 10.5948 17.9821 10.9353V15.004Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.1981 4H3.84992C2.82988 4 2 4.82988 2 5.84992V7.05875H23.048V5.84992C23.048 4.82988 22.2181 4 21.1981 4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.9a5141aaa7d07a24e438203d3311d061.svg";
export { ForwardRef as ReactComponent };